import { logger } from '../../../utils/logger';
import { SocketService } from '../../../SocketService';
import { MessageType } from '../../../types/MessageType';

/**
 * Pauses the connection of a SocketService instance.
 * If the keys have been exchanged, a PAUSE message is sent before
 * the socket is manually disconnected.
 *
 * @param instance The current instance of the SocketService.
 */
export async function pause(instance: SocketService) {
  logger.SocketService(
    `[SocketService: pause()] context=${instance.state.context}`,
  );

  instance.state.manualDisconnect = true;
  if (instance.state.keyExchange?.areKeysExchanged()) {
    await instance.sendMessage({ type: MessageType.PAUSE });
  }
  instance.state.socket?.disconnect();
}
